import { MDS_COLORS_BACKGROUND_ACCENT_WEAK, MDS_COLORS_BACKGROUND_DEFAULT, MDS_COLORS_LINE_BORDER, MDS_COLORS_LINE_BORDER_ACCENT, } from '@rappi/mustache-b2b-foundations';
import { Typography } from '@rappi/rests-commons-front';
import styled, { css } from 'styled-components';
export const Container = styled.button `
  cursor: pointer;
  width: 415px;
  border-radius: 16px;
  text-align: left;
  transition: all 0.2s ease-in-out;
  border: 2px solid ${MDS_COLORS_LINE_BORDER};
  background-color: transparent;

  &:hover {
    background-color: ${MDS_COLORS_BACKGROUND_DEFAULT};
    border-color: transparent;
  }

  ${({ $selected }) => $selected &&
    css `
      background-color: ${MDS_COLORS_BACKGROUND_ACCENT_WEAK};
      box-shadow: 0 0 0 2px ${MDS_COLORS_LINE_BORDER_ACCENT};
    `}
`;
export const BankName = styled(Typography) `
  font-weight: 500;
`;
export const CardNumberAccount = styled(Typography) `
  font-family: monospace;
`;
export const IconContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $color }) => $color};
`;
